import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import css from './ReportAd.scss';
import { injectIntl } from 'react-intl';
import withConfig from 'HOCs/withConfig/withConfig';
import { compose } from 'redux';
import { IS_DESKTOP } from 'Constants/device.APP_TARGET';

export const ReportAd = ({ itemId, internalId, config, intl }) => {
    const adID = intl.formatMessage({ id: 'adID' });
    const referenceID = intl.formatMessage({ id: 'referenceID', defaultMessage: 'REFERENCE ID' });
    const reportAdNew = intl.formatMessage({ id: 'reportAdNew' });
    const reportEmail = config.get('reportEmail');
    const formattedEmailBody = intl.formatMessage({
        id: 'emailBody'
    }, { itemId });
    const formattedSubject = intl.formatMessage({
        id: 'reportEmailSubject'
    }, { itemId });

    return (
        <>
            <div className={ css.reportAdTitle }>{adID}: {itemId}</div>
            {internalId && <div className={ css.reportAdTitle }>{referenceID}: {internalId}</div> }
            <div className={ classNames({
                [css.reportTextWrapper]: IS_DESKTOP
            }) }>
                {reportAdNew}
                <a
                    className={ classNames(css.anchorTag, {
                        [css.reportEmailLink]: !IS_DESKTOP
                    }) }
                    href={ `mailto:${reportEmail}?subject=${formattedSubject}&body=${encodeURIComponent(formattedEmailBody)}` }
                >
                    { reportEmail }
                </a>
            </div>
        </>
    );
};

ReportAd.propTypes = {
    itemId: PropTypes.string.isRequired,
    internalId: PropTypes.string,
    config: PropTypes.shape({
        get: PropTypes.func.isRequired
    }).isRequired,
    intl: PropTypes.shape({
        formatMessage: PropTypes.func.isRequired
    }).isRequired
};

export default compose(
    withConfig,
    injectIntl,
    React.memo
)(ReportAd);
